/** Platform-specific phrases for additional official Logto languages.
 * Common account and authentication labels are supplied by logto-catalog.ts. */
export const additionalMessages = {
  ar: {
    emailEntry: 'تسجيل الدخول بالبريد الإلكتروني',
    identifierEntry: 'تسجيل الدخول بحسابك',
    employeeEntry: 'دخول الموظفين',
    employeeHint: 'تابع إلى صفحة تسجيل الدخول لشركتك باستخدام حساب العمل.',
    continuing: 'جارٍ المتابعة…',
    language: 'اللغة',
    appearance: 'المظهر',
    light: 'فاتح',
    dark: 'داكن',
    system: 'حسب النظام',
    workspace: 'مساحة العمل',
    identity: 'منصة الهوية',
    signIn: 'تسجيل الدخول إلى LEXMOUNT',
    signInHint: 'حساب واحد لتطبيقاتك المتصلة.',
    footer: 'LEXMOUNT · هوية موحدة',
    preferences: 'التفضيلات',
    preferenceHint: 'تُحفظ التفضيلات في هذا المتصفح.',
    manage: 'إدارة',
    managed: 'تديره شركتك',
    readOnly: 'للقراءة فقط',
    registerUsernameNote: 'أنشئ اسم مستخدم وكلمة مرور لحساب المسؤول.',
    registerNote:
      'تحقق من بريدك الإلكتروني، ثم عيّن كلمة مرور. يمكنك أيضًا الدخول برمز عبر البريد.',
    pending: 'غير مفعّل',
    pendingHint: 'ستتوفر هذه الطريقة بعد أن يقوم المسؤول بإعدادها وتفعيلها.',
    back: 'العودة إلى تطبيقك ↗',
    shared: 'تسري التغييرات على جميع التطبيقات المتصلة.',
    avatarUrl: 'رابط HTTPS للصورة الشخصية',
    avatarHelp: 'أدخل رابط صورة HTTPS، أو اترك الحقل فارغًا لإزالة صورتك.',
    avatarInvalid: 'أدخل رابط صورة HTTPS صالحًا لا يحتوي على بيانات تسجيل دخول.',
    avatarBroken: 'الصورة غير متاحة',
    unset: 'غير محدد',
    savePending: 'جارٍ الحفظ…',
    updateError: 'تعذّر الحفظ. حاول مرة أخرى.',
    employeeManaged: 'تدير شركتك بريدك الإلكتروني وكلمة المرور. تواصل مع المسؤول لتغييرهما.',
    clearInput: 'مسح الحقل',
    languageError: 'تعذّر تغيير اللغة. حاول مرة أخرى.',
    loginWelcome: 'مرحبًا بك في LEXMOUNT',
    loginActionHint: 'سجّل الدخول للمتابعة إلى مساحة عملك.',
    loginFooter: 'تدير منصة الهوية حسابك',
  },
  cs: {
    emailEntry: 'Přihlásit se e-mailem',
    identifierEntry: 'Přihlásit se účtem',
    employeeEntry: 'Přihlášení zaměstnanců',
    employeeHint: 'Pokračujte na firemní přihlášení se svým pracovním účtem.',
    continuing: 'Pokračování…',
    language: 'Jazyk',
    appearance: 'Vzhled',
    light: 'Světlý',
    dark: 'Tmavý',
    system: 'Podle systému',
    workspace: 'Pracovní prostor',
    identity: 'Platforma identity',
    signIn: 'Přihlášení do LEXMOUNT',
    signInHint: 'Jeden účet pro vaše propojené aplikace.',
    footer: 'LEXMOUNT · Jednotná identita',
    preferences: 'Předvolby',
    preferenceHint: 'Předvolby se ukládají v tomto prohlížeči.',
    manage: 'Spravovat',
    managed: 'Spravováno vaší společností',
    readOnly: 'Pouze ke čtení',
    registerUsernameNote: 'Vytvořte uživatelské jméno a heslo účtu správce.',
    registerNote: 'Ověřte e-mail a nastavte heslo. Přihlašovat se můžete také kódem z e-mailu.',
    pending: 'Není povoleno',
    pendingHint: 'Tato metoda bude dostupná po nastavení a povolení správcem.',
    back: 'Zpět do aplikace ↗',
    shared: 'Změny se projeví ve všech propojených aplikacích.',
    avatarUrl: 'HTTPS adresa profilového obrázku',
    avatarHelp: 'Zadejte HTTPS adresu obrázku, nebo ponechte pole prázdné pro jeho odstranění.',
    avatarInvalid: 'Zadejte platnou HTTPS adresu obrázku bez přihlašovacích údajů.',
    avatarBroken: 'Obrázek není dostupný',
    unset: 'Nenastaveno',
    savePending: 'Ukládání…',
    updateError: 'Uložení se nezdařilo. Zkuste to znovu.',
    employeeManaged: 'Váš e-mail a heslo spravuje společnost. Pro změnu kontaktujte správce.',
    clearInput: 'Vymazat pole',
    languageError: 'Jazyk se nepodařilo změnit. Zkuste to znovu.',
    loginWelcome: 'Vítejte v LEXMOUNT',
    loginActionHint: 'Přihlaste se do svého pracovního prostoru.',
    loginFooter: 'Váš účet spravuje platforma identity',
  },
  'fa-IR': {
    emailEntry: 'ورود با ایمیل',
    identifierEntry: 'ورود با حساب کاربری',
    employeeEntry: 'ورود کارکنان',
    employeeHint: 'با حساب کاری خود به صفحه ورود شرکت بروید.',
    continuing: 'در حال ادامه…',
    language: 'زبان',
    appearance: 'ظاهر',
    light: 'روشن',
    dark: 'تیره',
    system: 'مطابق سیستم',
    workspace: 'فضای کاری',
    identity: 'پلتفرم هویت',
    signIn: 'ورود به LEXMOUNT',
    signInHint: 'یک حساب برای برنامه‌های متصل شما.',
    footer: 'LEXMOUNT · هویت یکپارچه',
    preferences: 'تنظیمات شخصی',
    preferenceHint: 'تنظیمات در این مرورگر ذخیره می‌شوند.',
    manage: 'مدیریت',
    managed: 'تحت مدیریت شرکت شما',
    readOnly: 'فقط خواندنی',
    registerUsernameNote: 'نام کاربری و رمز عبور حساب مدیر را ایجاد کنید.',
    registerNote: 'ایمیل را تأیید کنید و رمز عبور تعیین کنید. ورود با کد ایمیل نیز امکان‌پذیر است.',
    pending: 'فعال نشده',
    pendingHint: 'این روش پس از پیکربندی و فعال‌سازی توسط مدیر در دسترس خواهد بود.',
    back: 'بازگشت به برنامه ↗',
    shared: 'تغییرات در همه برنامه‌های متصل اعمال می‌شوند.',
    avatarUrl: 'نشانی HTTPS تصویر نمایه',
    avatarHelp: 'نشانی HTTPS تصویر را وارد کنید یا برای حذف تصویر، کادر را خالی بگذارید.',
    avatarInvalid: 'یک نشانی HTTPS معتبر برای تصویر بدون اطلاعات ورود وارد کنید.',
    avatarBroken: 'تصویر در دسترس نیست',
    unset: 'تنظیم نشده',
    savePending: 'در حال ذخیره…',
    updateError: 'ذخیره نشد. دوباره تلاش کنید.',
    employeeManaged:
      'ایمیل و رمز عبور شما توسط شرکت مدیریت می‌شود. برای تغییر با مدیر تماس بگیرید.',
    clearInput: 'پاک کردن کادر',
    languageError: 'تغییر زبان ناموفق بود. دوباره تلاش کنید.',
    loginWelcome: 'به LEXMOUNT خوش آمدید',
    loginActionHint: 'برای ادامه به فضای کاری خود وارد شوید.',
    loginFooter: 'حساب شما توسط پلتفرم هویت مدیریت می‌شود',
  },
  it: {
    emailEntry: 'Accedi con email',
    identifierEntry: 'Accedi con il tuo account',
    employeeEntry: 'Accesso dipendenti',
    employeeHint: 'Prosegui alla pagina di accesso aziendale con il tuo account di lavoro.',
    continuing: 'Proseguimento…',
    language: 'Lingua',
    appearance: 'Aspetto',
    light: 'Chiaro',
    dark: 'Scuro',
    system: 'Sistema',
    workspace: 'Area di lavoro',
    identity: 'Piattaforma di identità',
    signIn: 'Accedi a LEXMOUNT',
    signInHint: 'Un account per tutte le tue applicazioni collegate.',
    footer: 'LEXMOUNT · Identità unificata',
    preferences: 'Preferenze',
    preferenceHint: 'Le preferenze vengono salvate in questo browser.',
    manage: 'Gestisci',
    managed: 'Gestito dalla tua azienda',
    readOnly: 'Sola lettura',
    registerUsernameNote: 'Crea il nome utente e la password per il tuo account amministratore.',
    registerNote:
      'Verifica la tua email, poi imposta una password. Puoi anche accedere con un codice email.',
    pending: 'Non abilitato',
    pendingHint:
      'Questo metodo sarà disponibile dopo la configurazione e l’abilitazione da parte dell’amministratore.',
    back: 'Torna alla tua app ↗',
    shared: 'Le modifiche si applicano a tutte le app collegate.',
    avatarUrl: 'URL HTTPS dell’immagine del profilo',
    avatarHelp: 'Usa un URL HTTPS oppure lascia vuoto per rimuovere l’immagine.',
    avatarInvalid: 'Inserisci un URL HTTPS valido senza credenziali.',
    avatarBroken: 'Immagine non disponibile',
    unset: 'Non impostato',
    savePending: 'Salvataggio…',
    updateError: 'Salvataggio non riuscito. Riprova.',
    employeeManaged:
      'La tua azienda gestisce email e password. Contatta l’amministratore per modificarle.',
    clearInput: 'Svuota il campo',
    languageError: 'Impossibile cambiare lingua. Riprova.',
    loginWelcome: 'Benvenuto in LEXMOUNT',
    loginActionHint: 'Accedi per continuare alla tua area di lavoro.',
    loginFooter: 'Il tuo account è gestito dalla piattaforma di identità',
  },
  ko: {
    emailEntry: '이메일로 로그인',
    identifierEntry: '계정으로 로그인',
    employeeEntry: '직원 로그인',
    employeeHint: '업무 계정으로 회사 로그인 페이지에서 계속하세요.',
    continuing: '계속하는 중…',
    language: '언어',
    appearance: '화면 모드',
    light: '라이트',
    dark: '다크',
    system: '시스템 설정',
    workspace: '워크스페이스',
    identity: '통합 ID 플랫폼',
    signIn: 'LEXMOUNT 로그인',
    signInHint: '하나의 계정으로 연결된 앱을 이용하세요.',
    footer: 'LEXMOUNT · 통합 ID',
    preferences: '환경 설정',
    preferenceHint: '설정은 이 브라우저에 저장됩니다.',
    manage: '관리',
    managed: '회사에서 관리',
    readOnly: '읽기 전용',
    registerUsernameNote: '관리자 계정의 사용자 이름과 비밀번호를 만드세요.',
    registerNote:
      '이메일을 인증한 후 비밀번호를 설정하세요. 이메일 인증 코드로도 로그인할 수 있습니다.',
    pending: '사용 안 함',
    pendingHint: '관리자가 설정하고 활성화하면 사용할 수 있습니다.',
    back: '앱으로 돌아가기 ↗',
    shared: '변경 사항은 연결된 모든 앱에 적용됩니다.',
    avatarUrl: '프로필 사진 HTTPS URL',
    avatarHelp: 'HTTPS 이미지 URL을 입력하세요. 사진을 삭제하려면 비워 두세요.',
    avatarInvalid: '로그인 정보가 없는 올바른 HTTPS 이미지 URL을 입력하세요.',
    avatarBroken: '이미지를 사용할 수 없음',
    unset: '설정 안 됨',
    savePending: '저장 중…',
    updateError: '저장하지 못했습니다. 다시 시도하세요.',
    employeeManaged: '이메일과 비밀번호는 회사에서 관리합니다. 변경하려면 관리자에게 문의하세요.',
    clearInput: '입력 지우기',
    languageError: '언어를 변경하지 못했습니다. 다시 시도하세요.',
    loginWelcome: 'LEXMOUNT에 오신 것을 환영합니다',
    loginActionHint: '워크스페이스로 이동하려면 로그인하세요.',
    loginFooter: '계정은 통합 ID 플랫폼에서 관리됩니다',
  },
  'pl-PL': {
    emailEntry: 'Zaloguj się przez e-mail',
    identifierEntry: 'Zaloguj się na swoje konto',
    employeeEntry: 'Logowanie pracowników',
    employeeHint: 'Przejdź do strony logowania firmy, używając konta służbowego.',
    continuing: 'Przechodzenie…',
    language: 'Język',
    appearance: 'Wygląd',
    light: 'Jasny',
    dark: 'Ciemny',
    system: 'Systemowy',
    workspace: 'Obszar roboczy',
    identity: 'Platforma tożsamości',
    signIn: 'Zaloguj się do LEXMOUNT',
    signInHint: 'Jedno konto do połączonych aplikacji.',
    footer: 'LEXMOUNT · Jednolita tożsamość',
    preferences: 'Preferencje',
    preferenceHint: 'Preferencje są zapisywane w tej przeglądarce.',
    manage: 'Zarządzaj',
    managed: 'Zarządzane przez firmę',
    readOnly: 'Tylko do odczytu',
    registerUsernameNote: 'Utwórz nazwę użytkownika i hasło do konta administratora.',
    registerNote:
      'Zweryfikuj e-mail, a następnie ustaw hasło. Możesz też logować się kodem z e-maila.',
    pending: 'Nie włączono',
    pendingHint: 'Ta metoda będzie dostępna po skonfigurowaniu i włączeniu przez administratora.',
    back: 'Powrót do aplikacji ↗',
    shared: 'Zmiany dotyczą wszystkich połączonych aplikacji.',
    avatarUrl: 'Adres HTTPS zdjęcia profilowego',
    avatarHelp: 'Podaj adres HTTPS obrazu lub pozostaw pole puste, aby usunąć zdjęcie.',
    avatarInvalid: 'Podaj prawidłowy adres HTTPS obrazu bez danych logowania.',
    avatarBroken: 'Obraz niedostępny',
    unset: 'Nie ustawiono',
    savePending: 'Zapisywanie…',
    updateError: 'Nie udało się zapisać. Spróbuj ponownie.',
    employeeManaged:
      'Firma zarządza Twoim e-mailem i hasłem. Aby je zmienić, skontaktuj się z administratorem.',
    clearInput: 'Wyczyść pole',
    languageError: 'Nie udało się zmienić języka. Spróbuj ponownie.',
    loginWelcome: 'Witamy w LEXMOUNT',
    loginActionHint: 'Zaloguj się, aby przejść do obszaru roboczego.',
    loginFooter: 'Twoim kontem zarządza platforma tożsamości',
  },
  ru: {
    emailEntry: 'Войти по электронной почте',
    identifierEntry: 'Войти в свой аккаунт',
    employeeEntry: 'Вход для сотрудников',
    employeeHint: 'Перейдите на страницу входа компании с рабочей учётной записью.',
    continuing: 'Переход…',
    language: 'Язык',
    appearance: 'Оформление',
    light: 'Светлое',
    dark: 'Тёмное',
    system: 'Как в системе',
    workspace: 'Рабочее пространство',
    identity: 'Платформа идентификации',
    signIn: 'Вход в LEXMOUNT',
    signInHint: 'Один аккаунт для подключённых приложений.',
    footer: 'LEXMOUNT · Единая идентификация',
    preferences: 'Настройки',
    preferenceHint: 'Настройки сохраняются в этом браузере.',
    manage: 'Управление',
    managed: 'Управляется вашей компанией',
    readOnly: 'Только чтение',
    registerUsernameNote: 'Создайте имя пользователя и пароль для аккаунта администратора.',
    registerNote: 'Подтвердите почту и задайте пароль. Вы также сможете входить по коду из письма.',
    pending: 'Не включено',
    pendingHint: 'Этот способ станет доступен после настройки и включения администратором.',
    back: 'Вернуться в приложение ↗',
    shared: 'Изменения применяются ко всем подключённым приложениям.',
    avatarUrl: 'HTTPS-ссылка на фото профиля',
    avatarHelp: 'Укажите HTTPS-ссылку на изображение или оставьте поле пустым для удаления фото.',
    avatarInvalid: 'Введите корректную HTTPS-ссылку без данных для входа.',
    avatarBroken: 'Изображение недоступно',
    unset: 'Не задано',
    savePending: 'Сохранение…',
    updateError: 'Не удалось сохранить. Повторите попытку.',
    employeeManaged:
      'Компания управляет вашей почтой и паролем. Для изменения обратитесь к администратору.',
    clearInput: 'Очистить поле',
    languageError: 'Не удалось сменить язык. Повторите попытку.',
    loginWelcome: 'Добро пожаловать в LEXMOUNT',
    loginActionHint: 'Войдите, чтобы перейти в рабочее пространство.',
    loginFooter: 'Вашим аккаунтом управляет платформа идентификации',
  },
  th: {
    emailEntry: 'เข้าสู่ระบบด้วยอีเมล',
    identifierEntry: 'เข้าสู่ระบบด้วยบัญชีของคุณ',
    employeeEntry: 'เข้าสู่ระบบสำหรับพนักงาน',
    employeeHint: 'ไปยังหน้าเข้าสู่ระบบของบริษัทด้วยบัญชีงานของคุณ',
    continuing: 'กำลังดำเนินการ…',
    language: 'ภาษา',
    appearance: 'รูปแบบ',
    light: 'สว่าง',
    dark: 'มืด',
    system: 'ตามระบบ',
    workspace: 'พื้นที่ทำงาน',
    identity: 'แพลตฟอร์มข้อมูลประจำตัว',
    signIn: 'เข้าสู่ระบบ LEXMOUNT',
    signInHint: 'บัญชีเดียวสำหรับแอปที่เชื่อมต่อทั้งหมด',
    footer: 'LEXMOUNT · ข้อมูลประจำตัวแบบรวมศูนย์',
    preferences: 'การตั้งค่า',
    preferenceHint: 'การตั้งค่าจะถูกบันทึกในเบราว์เซอร์นี้',
    manage: 'จัดการ',
    managed: 'จัดการโดยบริษัทของคุณ',
    readOnly: 'อ่านอย่างเดียว',
    registerUsernameNote: 'สร้างชื่อผู้ใช้และรหัสผ่านสำหรับบัญชีผู้ดูแลระบบ',
    registerNote: 'ยืนยันอีเมลแล้วตั้งรหัสผ่าน คุณยังสามารถเข้าสู่ระบบด้วยรหัสทางอีเมลได้',
    pending: 'ยังไม่เปิดใช้งาน',
    pendingHint: 'วิธีนี้จะพร้อมใช้งานหลังจากผู้ดูแลระบบตั้งค่าและเปิดใช้งาน',
    back: 'กลับไปยังแอป ↗',
    shared: 'การเปลี่ยนแปลงมีผลกับแอปที่เชื่อมต่อทั้งหมด',
    avatarUrl: 'URL รูปโปรไฟล์แบบ HTTPS',
    avatarHelp: 'กรอก URL รูปภาพแบบ HTTPS หรือเว้นว่างไว้เพื่อลบรูปโปรไฟล์',
    avatarInvalid: 'กรอก URL รูปภาพแบบ HTTPS ที่ถูกต้องและไม่มีข้อมูลเข้าสู่ระบบ',
    avatarBroken: 'ไม่สามารถแสดงรูปภาพได้',
    unset: 'ยังไม่ได้ตั้งค่า',
    savePending: 'กำลังบันทึก…',
    updateError: 'บันทึกไม่สำเร็จ โปรดลองอีกครั้ง',
    employeeManaged: 'บริษัทจัดการอีเมลและรหัสผ่านของคุณ หากต้องการเปลี่ยน โปรดติดต่อผู้ดูแลระบบ',
    clearInput: 'ล้างข้อมูล',
    languageError: 'เปลี่ยนภาษาไม่สำเร็จ โปรดลองอีกครั้ง',
    loginWelcome: 'ยินดีต้อนรับสู่ LEXMOUNT',
    loginActionHint: 'เข้าสู่ระบบเพื่อไปยังพื้นที่ทำงานของคุณ',
    loginFooter: 'บัญชีของคุณจัดการโดยแพลตฟอร์มข้อมูลประจำตัว',
  },
  'tr-TR': {
    emailEntry: 'E-posta ile giriş yap',
    identifierEntry: 'Hesabınla giriş yap',
    employeeEntry: 'Çalışan girişi',
    employeeHint: 'İş hesabınızla şirketinizin giriş sayfasına devam edin.',
    continuing: 'Devam ediliyor…',
    language: 'Dil',
    appearance: 'Görünüm',
    light: 'Açık',
    dark: 'Koyu',
    system: 'Sistem',
    workspace: 'Çalışma alanı',
    identity: 'Kimlik platformu',
    signIn: 'LEXMOUNT’a giriş yap',
    signInHint: 'Bağlı uygulamalarınız için tek hesap.',
    footer: 'LEXMOUNT · Birleşik kimlik',
    preferences: 'Tercihler',
    preferenceHint: 'Tercihler bu tarayıcıda kaydedilir.',
    manage: 'Yönet',
    managed: 'Şirketiniz tarafından yönetiliyor',
    readOnly: 'Salt okunur',
    registerUsernameNote: 'Yönetici hesabınız için kullanıcı adı ve parola oluşturun.',
    registerNote:
      'E-postanızı doğrulayıp bir parola belirleyin. E-posta koduyla da giriş yapabilirsiniz.',
    pending: 'Etkin değil',
    pendingHint: 'Bu yöntem, yöneticiniz yapılandırıp etkinleştirdikten sonra kullanılabilir.',
    back: 'Uygulamanıza dönün ↗',
    shared: 'Değişiklikler tüm bağlı uygulamalara uygulanır.',
    avatarUrl: 'HTTPS profil resmi adresi',
    avatarHelp: 'Bir HTTPS resim adresi girin veya resmi kaldırmak için boş bırakın.',
    avatarInvalid: 'Kimlik bilgisi içermeyen geçerli bir HTTPS resim adresi girin.',
    avatarBroken: 'Resim kullanılamıyor',
    unset: 'Ayarlanmamış',
    savePending: 'Kaydediliyor…',
    updateError: 'Kaydedilemedi. Lütfen tekrar deneyin.',
    employeeManaged:
      'E-posta ve parolanızı şirketiniz yönetir. Değiştirmek için yöneticinizle iletişime geçin.',
    clearInput: 'Alanı temizle',
    languageError: 'Dil değiştirilemedi. Lütfen tekrar deneyin.',
    loginWelcome: 'LEXMOUNT’a hoş geldiniz',
    loginActionHint: 'Çalışma alanınıza devam etmek için giriş yapın.',
    loginFooter: 'Hesabınız kimlik platformu tarafından yönetilir',
  },
  'uk-UA': {
    emailEntry: 'Увійти за електронною поштою',
    identifierEntry: 'Увійти у свій обліковий запис',
    employeeEntry: 'Вхід для співробітників',
    employeeHint: 'Перейдіть на сторінку входу компанії з робочим обліковим записом.',
    continuing: 'Перехід…',
    language: 'Мова',
    appearance: 'Оформлення',
    light: 'Світле',
    dark: 'Темне',
    system: 'Як у системі',
    workspace: 'Робочий простір',
    identity: 'Платформа ідентифікації',
    signIn: 'Вхід до LEXMOUNT',
    signInHint: 'Один обліковий запис для підключених застосунків.',
    footer: 'LEXMOUNT · Єдина ідентифікація',
    preferences: 'Налаштування',
    preferenceHint: 'Налаштування зберігаються в цьому браузері.',
    manage: 'Керувати',
    managed: 'Керує ваша компанія',
    readOnly: 'Лише читання',
    registerUsernameNote:
      'Створіть ім’я користувача та пароль для облікового запису адміністратора.',
    registerNote: 'Підтвердьте пошту та встановіть пароль. Також можна входити за кодом із листа.',
    pending: 'Не ввімкнено',
    pendingHint: 'Цей спосіб стане доступним після налаштування та ввімкнення адміністратором.',
    back: 'Повернутися до застосунку ↗',
    shared: 'Зміни застосовуються до всіх підключених застосунків.',
    avatarUrl: 'HTTPS-посилання на фото профілю',
    avatarHelp:
      'Введіть HTTPS-посилання на зображення або залиште поле порожнім, щоб видалити фото.',
    avatarInvalid: 'Введіть коректне HTTPS-посилання без даних для входу.',
    avatarBroken: 'Зображення недоступне',
    unset: 'Не встановлено',
    savePending: 'Збереження…',
    updateError: 'Не вдалося зберегти. Спробуйте ще раз.',
    employeeManaged:
      'Компанія керує вашою поштою та паролем. Для зміни зверніться до адміністратора.',
    clearInput: 'Очистити поле',
    languageError: 'Не вдалося змінити мову. Спробуйте ще раз.',
    loginWelcome: 'Ласкаво просимо до LEXMOUNT',
    loginActionHint: 'Увійдіть, щоб перейти до робочого простору.',
    loginFooter: 'Вашим обліковим записом керує платформа ідентифікації',
  },
  'zh-TW': {
    emailEntry: '電子郵件登入',
    identifierEntry: '帳號登入',
    employeeEntry: '員工登入',
    employeeHint: '使用工作帳號，前往公司的登入頁面繼續。',
    continuing: '正在繼續…',
    language: '語言',
    appearance: '外觀',
    light: '淺色',
    dark: '深色',
    system: '跟隨系統',
    workspace: '工作區',
    identity: '統一身分平台',
    signIn: '登入 LEXMOUNT',
    signInHint: '使用同一帳號存取所有已連接的應用程式。',
    footer: 'LEXMOUNT · 統一身分',
    preferences: '偏好設定',
    preferenceHint: '偏好設定儲存在目前的瀏覽器中。',
    manage: '管理',
    managed: '由公司管理',
    readOnly: '唯讀',
    registerUsernameNote: '建立管理員使用者名稱並設定密碼。',
    registerNote: '驗證電子郵件後設定密碼，也可以使用電子郵件驗證碼登入。',
    pending: '未啟用',
    pendingHint: '管理員設定並啟用後，即可使用此登入方式。',
    back: '返回原網站 ↗',
    shared: '資料變更會套用至所有已連接的應用程式。',
    avatarUrl: 'HTTPS 頭像網址',
    avatarHelp: '填寫 HTTPS 圖片網址；留空儲存即可移除頭像。',
    avatarInvalid: '請輸入不含登入憑證的有效 HTTPS 圖片網址。',
    avatarBroken: '暫時無法顯示圖片',
    unset: '未設定',
    savePending: '儲存中…',
    updateError: '更新失敗，請稍後再試。',
    employeeManaged: '公司統一管理你的電子郵件和密碼。如需修改，請聯絡管理員。',
    clearInput: '清除輸入',
    languageError: '無法切換語言，請稍後再試。',
    loginWelcome: '歡迎使用 LEXMOUNT',
    loginActionHint: '登入以繼續前往你的工作區。',
    loginFooter: '帳號由統一身分平台管理',
  },
};
